var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'no-border': _vm.item.text.length === 0, 'has-bg': _vm.item.hasBg },on:{"click":function($event){return _vm.$emit('select-schedule', { item: _vm.item })}}},[_c('span',[_vm._v(_vm._s(_vm.item.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }